// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "p[data-v-06ffcce8] {\n  margin-bottom: 0px;\n}\np.red[data-v-06ffcce8] {\n  color: #af0202;\n  font-weight: 400;\n  margin-bottom: revert;\n}", ""]);
// Exports
module.exports = exports;
